import axios from 'axios';

// Em desenvolvimento, usar URL completa; em produção, usar path relativo
const API_URL = process.env.NODE_ENV === 'development' 
  ? process.env.REACT_APP_API_URL || 'http://localhost:3001/api'
  : process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authService = {
  login: (email: string, password: string) =>
    api.post('/auth/login', { email, password }),
  register: (name: string, email: string, password: string, token: string) =>
    api.post('/auth/register', { name, email, password, token }),
  getProfile: () => api.get('/auth/profile'),
};

export const botService = {
  create: (data: any) => api.post('/bots', data),
  list: () => api.get('/bots'),
  get: (id: string) => api.get(`/bots/${id}`),
  update: (id: string, data: any) => api.put(`/bots/${id}`, data),
  delete: (id: string) => api.delete(`/bots/${id}`),
  toggle: (id: string, isActive: boolean) =>
    api.patch(`/bots/${id}/toggle`, { isActive }),
  getAssistants: (openaiKey: string) =>
    api.post('/bots/assistants', { openaiKey }),
  getDashboardStats: () => api.get('/bots/stats/dashboard'),
  createShareLink: (id: string) => api.post(`/bots/${id}/share-qr`),
};

export const whatsappService = {
  connect: (botId: string) => api.post(`/whatsapp/${botId}/connect`),
  disconnect: (botId: string) => api.post(`/whatsapp/${botId}/disconnect`),
  getQR: (botId: string) => api.get(`/whatsapp/${botId}/qr`),
  getStatus: (botId: string) => api.get(`/whatsapp/${botId}/status`),
};

export const logService = {
  getLogs: (botId: string, limit = 100, offset = 0) =>
    api.get(`/logs/${botId}?limit=${limit}&offset=${offset}`),
  getStats: (botId: string) => api.get(`/logs/${botId}/stats`),
};

export const conversationService = {
  getConversations: (botId: string) => 
    api.get(`/bots/${botId}/conversations`),
  
  getConversation: (conversationId: string) => 
    api.get(`/conversations/${conversationId}`),
  
  getMessages: (conversationId: string, limit = 100, offset = 0) => 
    api.get(`/conversations/${conversationId}/messages`, {
      params: { limit, offset }
    }),
  
  sendMessage: (conversationId: string, message: string) => 
    api.post(`/conversations/${conversationId}/messages`, { message }),
  
  toggleManualMode: (conversationId: string, isManual: boolean) => 
    api.put(`/conversations/${conversationId}/manual-mode`, { isManual })
};

export default api;